<div class="quiz-shell" [class.quiz-shell--reduced]="reducedMotion" [class.quiz-shell--topbar-hidden]="hideTopBar">
  <div class="quiz-shell__wrapper" [class.is-narrow]="variant === 'narrow'" [class.is-wide]="variant === 'wide'">
    <div class="quiz-shell__topbar">
    <header class="quiz-shell__header">
      <div class="quiz-shell__header-left">
        <button
          *ngIf="showBack"
          type="button"
          class="quiz-shell__back"
          (click)="onBack()"
          [attr.aria-label]="'compilation_back' | translate">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </button>

        <button
          *ngIf="showForward"
          type="button"
          class="quiz-shell__forward"
          (click)="onForward()"
          [attr.aria-label]="'compilation_forward' | translate">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </button>

        <h1 class="quiz-shell__title" *ngIf="title">{{ title }}</h1>

        <ng-content select="[quizHeaderLeft]"></ng-content>
      </div>

      <div class="quiz-shell__header-center">
        <img
          [src]="custLogo || 'assets/logo-light.png'"
          [alt]="'compilation_logoAlt' | translate"
          class="quiz-shell__cust-logo" />
      </div>

      <div class="quiz-shell__header-right">
        <!-- Language dropdown (solo se il questionario ha più lingue) -->
        <div class="quiz-shell__lang" *ngIf="availableLanguages && availableLanguages.length > 1">
          <button type="button"
                  class="quiz-shell__lang-trigger"
                  (click)="toggleLangMenu($event)"
                  [class.is-open]="langMenuOpen"
                  [attr.aria-expanded]="langMenuOpen"
                  aria-haspopup="listbox"
                  [attr.aria-label]="'selectLanguage' | translate">
            <span class="quiz-shell__lang-current quiz-shell__lang-current--full">{{ getLanguageLabel(currentLanguage) }}</span>
            <span class="quiz-shell__lang-current quiz-shell__lang-current--short">{{ currentLanguage === 'ITA' ? 'ITA' : 'ENG' }}</span>
            <svg class="quiz-shell__lang-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M6 9l6 6 6-6"/>
            </svg>
          </button>

          <ul class="quiz-shell__lang-menu" *ngIf="langMenuOpen" role="listbox" (click)="$event.stopPropagation()">
            <li *ngFor="let lang of availableLanguages"
                role="option"
                [attr.aria-selected]="currentLanguage === lang">
              <button type="button"
                      class="quiz-shell__lang-option"
                      [class.is-active]="currentLanguage === lang"
                      (click)="onLanguageSelect(lang, $event)">
                {{ getLanguageLabel(lang) }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </header>

    <div class="quiz-shell__separator" *ngIf="showProgress">
      <div
        class="quiz-shell__progress"
        role="progressbar"
        [attr.aria-valuenow]="progressValue"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-label]="'compilation_progress' | translate">
        <div class="quiz-shell__progress-bar" [style.width.%]="progressValue"></div>
      </div>
    </div>
    </div>

    <main class="quiz-shell__content" [class.is-centered]="centered">
      <ng-content></ng-content>
    </main>
  </div>
</div>
